import React, { useEffect, useState } from 'react';
import { getData } from '../../../webService/webservice.js';
import { toast } from 'react-toastify';

const PaymentHistoryPage = () => {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchHistory();
    }, []);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("Token");
            const res = await getData('payments/history', {}, token);
            if (res?.success) {
                setPayments(res.data);
            } else {
                toast.error("Failed to load payment history");
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>Payment History</h2>
            <div className="table-responsive">
                <table className="table table-bordered table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th>Order ID</th>
                            <th>Store</th>
                            <th>Package Name</th>
                            <th>Total Amount (INR)</th>
                            <th>Status</th>
                            <th>Gateway</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="7" className="text-center">Loading...</td></tr>
                        ) : payments.length === 0 ? (
                            <tr><td colSpan="7" className="text-center">No payment history found.</td></tr>
                        ) : payments.map(payment => (
                            <tr key={payment._id}>
                                <td>{payment.internalOrderId}</td>
                                <td>{payment.storeId?.storeName || 'Unknown'}</td>
                                <td>{payment.packageName}</td>
                                <td>₹{payment.totalAmount}</td>
                                <td>
                                    <span className={`badge bg-${payment.paymentStatus === 'SUCCESS' ? 'success' : payment.paymentStatus === 'FAILED' ? 'danger' : 'warning'}`}>
                                        {payment.paymentStatus}
                                    </span>
                                </td>
                                <td>{payment.paymentGateway}</td>
                                <td>{new Date(payment.createdAt).toLocaleDateString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PaymentHistoryPage;
